import type { LifeSpace } from '@/src/renderer/lib/db/models'
import { MOVE_LIFE_SPACES } from '../../utils/moveTargets'

/**
 * **Der zuletzt gewählte Lebensbereich im Verschieben-Panel** (#279, Sven 06.10.2026): Das Panel öffnet
 * wieder auf ihm — wer viele Aufgaben nach „Privat“ einsortiert, wählt den Bereich nur einmal.
 *
 * **Gerätelokal** wie der Reiter der Details (`lastDetailsTab.ts`): eine Gewohnheit der Ansicht, kein
 * Inhalt, also kein Sync. Ohne Modul-Cache — zwei Electron-Fenster teilen den Speicher.
 */
export const LAST_MOVE_SPACE_KEY = 'happytask:move:lastSpace'

const isMoveSpace = (value: unknown): value is LifeSpace => MOVE_LIFE_SPACES.includes(value as LifeSpace)

/** `null`: nichts gemerkt oder kein lesbarer Wert — dann gilt der Bereich der Aufgabe. */
export function readLastMoveSpace(): LifeSpace | null {
  try {
    const raw = localStorage.getItem(LAST_MOVE_SPACE_KEY)
    return isMoveSpace(raw) ? raw : null
  } catch {
    // Im privaten Fenster wirft schon das Lesen.
    return null
  }
}

export function rememberMoveSpace(space: LifeSpace): void {
  try {
    localStorage.setItem(LAST_MOVE_SPACE_KEY, space)
  } catch {
    // Kein Speicher (privates Fenster, volles Kontingent) — dann gilt die Wahl nur, solange das Panel offen ist.
  }
}
